var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerydissatisfied(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0245 35C26.4268 35 34.0489 27.165 34.0489 17.5C34.0489 7.83502 26.4268 0 17.0245 0C7.62211 0 0 7.83502 0 17.5C0 27.165 7.62211 35 17.0245 35Z",
    fill: "url(#paint0_radial_321_7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.0245 35C26.4268 35 34.0489 27.165 34.0489 17.5C34.0489 7.83502 26.4268 0 17.0245 0C7.62211 0 0 7.83502 0 17.5C0 27.165 7.62211 35 17.0245 35Z",
    fill: "url(#paint1_radial_321_7)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6732 25.6485L15.7906 27.4204C16.5035 28.022 17.5356 28.022 18.2485 27.4204L20.366 25.6485L22.4834 27.4204C23.1963 28.022 24.2284 28.022 24.9519 27.4204L26.2288 26.3485C26.4309 26.1845 26.548 25.9329 26.548 25.6595C26.548 25.386 26.4309 25.1454 26.2288 24.9704C25.9095 24.7079 25.452 24.7079 25.1434 24.9704L23.7283 26.1626L21.5257 24.3251C20.8554 23.7673 19.8871 23.7673 19.2168 24.3251L17.0249 26.1626L14.8224 24.3251C14.152 23.7673 13.1838 23.7673 12.5134 24.3251L10.3215 26.1626L8.89573 24.9704C8.57652 24.7079 8.11899 24.7079 7.81042 24.9704C7.60825 25.1345 7.49121 25.386 7.49121 25.6595C7.49121 25.9329 7.60825 26.1735 7.81042 26.3485L9.08725 27.4204C9.80015 28.022 10.8323 28.022 11.5558 27.4204L13.6732 25.6485Z",
    fill: "#643800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2492 24.9704C25.9299 24.7079 25.4724 24.7079 25.1638 24.9704L24.4084 25.6048C24.0147 25.9329 23.4614 25.9329 23.0677 25.6048L21.5355 24.3251C20.8652 23.7673 19.8969 23.7673 19.2266 24.3251L17.6944 25.6048C17.3007 25.9329 16.7474 25.9329 16.3537 25.6048L14.8215 24.3251C14.1512 23.7673 13.1829 23.7673 12.5126 24.3251L10.9803 25.6048C10.5867 25.9329 10.0334 25.9329 9.63967 25.6048L8.88421 24.9704C8.565 24.7079 8.10747 24.7079 7.7989 24.9704C7.64994 25.1017 7.54354 25.2657 7.50098 25.4626C8.69269 24.8173 9.37367 26.7423 10.3313 26.7423C11.1825 26.7423 12.4806 24.5329 13.6511 24.5329C14.6512 24.5329 16.1196 26.7204 17.024 26.7204C17.9285 26.7204 19.3968 24.5329 20.397 24.5329C21.5674 24.5329 22.8549 26.7423 23.7168 26.7423C24.6744 26.7423 25.3554 24.8173 26.5471 25.4626C26.4939 25.2767 26.3981 25.1017 26.2492 24.9704Z",
    fill: "url(#paint2_linear_321_7)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95824 8.54185C5.86248 9.24185 6.53282 9.77779 7.78837 9.96373C8.8524 10.1169 11.2784 9.85435 13.1936 7.95123C13.5448 7.60123 13.1191 7.31685 12.7893 7.5356C11.6721 8.25748 8.86304 8.97935 6.8201 8.45435C6.0008 8.22467 5.95824 8.54185 5.95824 8.54185Z",
    fill: "url(#paint3_linear_321_7)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41628 12.3378C6.48012 12.1409 6.66101 12.0315 6.86317 12.0644C7.91656 12.2831 9.71477 13.0815 11.4279 14.0987C12.7898 14.8972 14.3752 16.9425 14.1837 17.6425C13.9709 18.4081 11.8428 18.9878 10.9384 19.2065C9.52324 19.5456 7.66119 19.7972 6.68229 19.5128C6.42692 19.4362 6.3418 19.2503 6.3418 19.0972C6.35244 18.8894 6.52268 18.7144 6.78869 18.6597C9.65093 18.08 11.5662 17.3362 11.5981 16.8878C11.5981 16.8878 11.7364 16.1878 9.93821 14.9847C8.84226 14.2519 7.63991 13.6175 6.89509 13.2456C6.46948 12.9831 6.33116 12.6222 6.41628 12.3378Z",
    fill: "url(#paint4_radial_321_7)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86291 12.0644C7.9163 12.2831 9.76771 12.8519 11.4276 14.0988C12.9492 15.2363 14.3749 16.9425 14.1834 17.6425C14.0557 18.0909 13.2896 18.4738 12.4916 18.7581C12.4597 18.7691 12.4278 18.78 12.3959 18.7909H12.3852C13.1407 18.1894 13.5982 17.4347 12.7683 16.3519C12.2363 15.6738 10.6721 13.5847 6.41602 12.3269C6.47986 12.1409 6.66074 12.0316 6.86291 12.0644Z",
    fill: "url(#paint5_linear_321_7)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3418 19.0971C6.35244 18.8893 6.52268 18.7143 6.78869 18.6596C9.65093 18.0799 11.5662 17.3361 11.5981 16.8877C11.5449 17.6533 11.513 18.0252 9.12955 18.5721C7.36327 18.9768 6.53332 19.1299 6.67165 19.5127C6.42692 19.4361 6.3418 19.2502 6.3418 19.0971Z",
    fill: "url(#paint6_linear_321_7)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0908 8.54185C28.1865 9.24185 27.5162 9.77779 26.2606 9.96373C25.1966 10.1169 22.7706 9.85435 20.8554 7.95123C20.5042 7.60123 20.9299 7.31685 21.2597 7.5356C22.3769 8.25748 25.186 8.97935 27.2289 8.45435C28.0482 8.22467 28.0908 8.54185 28.0908 8.54185Z",
    fill: "url(#paint7_linear_321_7)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6328 12.3378C27.569 12.1409 27.3881 12.0315 27.1859 12.0644C26.1325 12.2831 24.3343 13.0815 22.6213 14.0987C21.2593 14.8972 19.6739 16.9425 19.8654 17.6425C20.0782 18.4081 22.2063 18.9878 23.1107 19.2065C24.5259 19.5456 26.3879 19.7972 27.3668 19.5128C27.6222 19.4362 27.7073 19.2503 27.7073 19.0972C27.6967 18.8894 27.5264 18.7144 27.2604 18.6597C24.3982 18.08 22.4829 17.3362 22.451 16.8878C22.451 16.8878 22.3127 16.1878 24.1109 14.9847C25.2068 14.2519 26.4092 13.6175 27.154 13.2456C27.5796 12.9831 27.7179 12.6222 27.6328 12.3378Z",
    fill: "url(#paint8_radial_321_7)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1855 12.0644C26.1321 12.2831 24.2807 12.8519 22.6208 14.0988C21.0993 15.2363 19.6735 16.9425 19.865 17.6425C19.9927 18.0909 20.7588 18.4738 21.5568 18.7581C21.5887 18.7691 21.6206 18.78 21.6526 18.7909H21.6632C20.9077 18.1894 20.4502 17.4347 21.2802 16.3519C21.8122 15.6738 23.3763 13.5847 27.6324 12.3269C27.5686 12.1409 27.3877 12.0316 27.1855 12.0644Z",
    fill: "url(#paint9_linear_321_7)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7075 19.0971C27.6968 18.8893 27.5266 18.7143 27.2606 18.6596C24.3983 18.0799 22.4831 17.3361 22.4512 16.8877C22.5044 17.6533 22.5363 18.0252 24.9197 18.5721C26.686 18.9768 27.5159 19.1299 27.3776 19.5127C27.6223 19.4361 27.7075 19.2502 27.7075 19.0971Z",
    fill: "url(#paint10_linear_321_7)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_321_7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.6749 10.4078) scale(20.5378 21.1115)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB92E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_321_7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.6749 10.4078) scale(16.158 16.6093)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_321_7",
    x1: 17.0238,
    y1: 25.2037,
    x2: 17.0238,
    y2: 31.2648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_321_7",
    x1: 8.44754,
    y1: 10.7381,
    x2: 10.0688,
    y2: 7.4275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_321_7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.81978 16.7022) rotate(-58.6949) scale(4.08503 2.61016)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_321_7",
    x1: 14.4189,
    y1: 16.8187,
    x2: 5.84031,
    y2: 14.4467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_321_7",
    x1: 11.48,
    y1: 18.3586,
    x2: 6.38245,
    y2: 18.0325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_321_7",
    x1: 25.6104,
    y1: 10.7375,
    x2: 23.9891,
    y2: 7.42687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_321_7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2134 16.6799) rotate(-121.305) scale(4.08503 2.61016)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_321_7",
    x1: 19.6326,
    y1: 16.8123,
    x2: 28.2112,
    y2: 14.4402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_321_7",
    x1: 22.5421,
    y1: 18.3568,
    x2: 27.6397,
    y2: 18.0307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerydissatisfied);
export default __webpack_public_path__ + "static/media/Very dissatisfied.f68c1c63b57347f9a0396555852bede9.svg";
export { ForwardRef as ReactComponent };